import React from "react";
// import Icon1 from "../assets/images/roadmapicons/icon1.png";

const Roadmap = () => {
  const data = [
    {
      title: "Phase 1",
      list: [
        "Commence fair launch",
        "Establish robust community",
        "Our clean and stylized website will be launched ",
        "Keep community engagement up through constant giveaways",
        "Form strong link between the team and the community",
        "Establish relations with well known influencers ",
        "Carry out heavy social media campaign ",
        "We will unleash a surprising utility",
      ],
    },
    {
      title: "Phase 2",
      list: [
        "We will seek out partnerships",
        "Ensure community involvement through contests and giveaways",
        "Hopefully have weekly jackpots ",
        "To expand, we will list on CEX exchanges",
      ],
    },
    {
      title: "Phase 3",
      list: [
        "The team will seek out ways to give all of you an opportunity to gain wealth (more jackpots, contests, and so on)",
        "We will carry out an expansive and far-reaching marketing campaign ",
        "We hope to release our breath-taking utility that will leave all in awe you.",
      ],
    },
  ];
  return (
    <section className="py-10">
      <div className="container">
        <h2 className="text-[30px] md:text-[60px] text-center uppercase text-primary-text">
          ROADMAP
        </h2>
        <p className=" font-serif text-center text-primary-text text-xl mt-4">
          Our plans for the future of Mozzle Doge
        </p>
        {/* <div className=" md:block hidden">
          <img src={RoadmapImage} alt="" className="mt-20" />
        </div> */}
        {/* <div className="grid md:hidden gap-10 mt-10 ">
          {data.map((val, i) => (
            <div
              key={i}
              className="flex flex-col justify-center items-center text-center bg-primary  rounded-xl p-2 py-6"
            >
              <h4 className=" text-2xl uppercase ">{val.title}</h4>
              <span className="font-serif text-sm text-gray-200">
                {val.date}
              </span>
              <img src={val.icon} className="w-14 mt-4 mb-8" alt="" />
              <p className=" font-serif ">{val.text}</p>
            </div>
          ))}
        </div> */}

        <div className="grid md:grid-cols-9 gap-4 md:gap-0  mt-20 max-w-3xl mx-auto ">
          {data.map((val, i) => {
            return (
              <>
                <>
                  {i % 2 === 0 ? (
                    <div
                      className="bg-primary p-4 py-5 rounded-xl  min-h-[300px] md:col-span-4 md:translate-x-4 relative z-10"
                      key={i}
                    >
                      {/* <div className="absolute bg-white h-2 w-20 top-1/2"></div> */}
                      <h2 className="text-xl">{val.title}</h2>
                      <ul className="mt-4">
                        {val.list.map((value, ind) => (
                          <li key={ind} className="flex justify-start ">
                            {" "}
                            <p className="mr-1">-</p> <p>{value}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <div className="col-span-4 md:block hidden"></div>
                  )}
                  <div className="col-span-1 md:block hidden ">
                    <div
                      className={` bg-white max-w-[20px] h-full mx-auto  ${
                        i === 0
                          ? "rounded-t-2xl"
                          : i === data.length - 1 && "rounded-b-2xl"
                      }`}
                    ></div>
                  </div>
                  {i % 2 === 1 ? (
                    <div
                      className="bg-primary p-4 py-5 rounded-xl  min-h-[300px] md:col-span-4 md:-translate-x-4"
                      key={i}
                    >
                      <h2 className="text-xl">{val.title}</h2>
                      <ul className="mt-4">
                        {val.list.map((value, ind) => (
                          <li key={ind} className="flex justify-start ">
                            {" "}
                            <p className="mr-1">-</p> <p>{value}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <div className="col-span-4 md:block hidden"></div>
                  )}
                </>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
